var styles = {"breakpoint-sm":"(min-width: 768px)","breakpointSm":"(min-width: 768px)","light":"styles_light__30sXY","arrow":"styles_arrow__3UxS6","dark":"styles_dark__vyPew","tooltip":"styles_tooltip__1-Cnl","title":"styles_title__Rs5QA","message":"styles_message__J1L4j","footer":"styles_footer__1EHNO","small":"styles_small__wv2e-","large":"styles_large__1CJkQ"};

export default styles;
//# sourceMappingURL=styles.css.js.map
